module.exports = __webpack_public_path__ + "img/verify1.f4b7263d.jpg";